import { FC, useContext } from "react";
import { Button } from "@src/lib/ui/Button";
import { cn } from "@src/lib/utils/cn";
import UserContext from "@src/lib/contexts/UserContext";
import useOpenIntercom from "@src/features/app/hooks/useOpenIntercom";
import { CommsOptInEventType } from "@src/types.generated";
import useRecordCommsOptInEvent from "./useRecordCommsOptInEvent";

const HAVE_A_QUESTION_MESSAGE =
  "I have a question about enabling Newsfeed and Messages: ";

type Props = {
  // "link" is the Home card's underlined text link; "button" the setup page's;
  // "inline" an underlined link inside a sentence, in the sentence's type.
  appearance?: "button" | "link" | "inline";
  label?: string;
};

const HaveAQuestionButton: FC<Props> = ({
  appearance = "button",
  label = "Have a question?",
}) => {
  const userContext = useContext(UserContext);
  const { showNewMessage } = useOpenIntercom(userContext);
  const recordEvent = useRecordCommsOptInEvent();
  const ask = () => {
    showNewMessage(HAVE_A_QUESTION_MESSAGE);
    recordEvent(CommsOptInEventType.ClickedHaveAQuestion);
  };
  if (appearance === "inline") {
    return (
      <button
        type="button"
        className="underline underline-offset-2 hover:text-text-primary"
        onClick={ask}
      >
        {label}
      </button>
    );
  }
  return (
    <Button
      variant={appearance === "link" ? "link" : "outline"}
      size={appearance === "link" ? "default" : "md"}
      className={cn(
        appearance === "link" && "h-auto p-0 text-text-primary underline",
      )}
      onClick={ask}
    >
      {label}
    </Button>
  );
};

export default HaveAQuestionButton;
